import {
  CalendarDays, Users, PhoneCall, FileText, BarChart3, Smartphone, Zap, Building2,
  BookOpen, Rocket, PlayCircle, Megaphone, LifeBuoy, Mail, Newspaper, Scale,
} from "lucide-react";
import { INDUSTRIES } from "../../data/industriesData";

export const PRODUCT_FEATURES = [
  { label: "Scheduling & Dispatch", desc: "Drag-and-drop calendar & smart dispatch", icon: CalendarDays, href: "/features/job-scheduling" },
  { label: "Customer CRM", desc: "Full history on every customer", icon: Users, href: "/features/crm" },
  { label: "Business Phone & SMS", desc: "Calls, texting & call masking", icon: PhoneCall, href: "/features/business-phone" },
  { label: "Estimates & Invoicing", desc: "E-signatures & card payments", icon: FileText, href: "/features/invoicing" },
  { label: "Financial Reporting", desc: "Job profit & commissions", icon: BarChart3, href: "/features/financial-reporting" },
  { label: "Technician Mobile App", desc: "Field portal for your techs", icon: Smartphone, href: "/features/technician-app" },
  { label: "Automations & Leads", desc: "Reminders, reviews & lead forms", icon: Zap, href: "/features/automations" },
  { label: "Multi-Location", desc: "All branches, one dashboard", icon: Building2, href: "/multi-location" },
];

const INDUSTRY_TAGLINES = {
  locksmith: "Urgent dispatch & call masking",
  hvac: "Seasonal scheduling & job costing",
  plumbing: "Emergency dispatch & photo docs",
  electrical: "Multi-visit projects & estimates",
  "garage-door": "Same-day service & parts tracking",
  "appliance-repair": "Time windows & customer history",
  cleaning: "Recurring schedules & reminders",
  handyman: "Fast quotes for varied jobs",
};

export const INDUSTRIES_NAV = INDUSTRIES.map((i) => ({
  label: i.name,
  desc: INDUSTRY_TAGLINES[i.slug] || "Field service software for your trade",
  icon: i.icon,
  href: `/industries/${i.slug}`,
}));

export const RESOURCES = [
  { label: "Blog", desc: "Guides & growth playbooks", icon: Newspaper, href: "/blog" },
  { label: "Documentation", desc: "Guides for every feature", icon: BookOpen, href: "/docs" },
  { label: "Quick Start", desc: "Get set up in minutes", icon: Rocket, href: "/quick-start" },
  { label: "Video Tutorials", desc: "Watch and learn", icon: PlayCircle, href: "/tutorials" },
  { label: "Compare", desc: "Fieldz AI vs other software", icon: Scale, href: "/compare" },
  { label: "Release Notes", desc: "What's new in Fieldz AI", icon: Megaphone, href: "/release-notes" },
  { label: "Support Center", desc: "FAQs and help articles", icon: LifeBuoy, href: "/support" },
  { label: "Contact Us", desc: "Talk to our team", icon: Mail, href: "/contact" },
];
